import React, { Component } from 'react';
import {setAndGetAttributes} from './FormInputFunctions';
import Wrp from "../../hoc/Wrp/Wrp";

class OnAndOffField extends Component {
  
  fieldOnChangeHandler = (e)=>{
    const {changeHandler} = this.props;
    //console.log('e.target.checked==')
    changeHandler(e.target.checked);
  } 

  render() {
    const {value} = this.props;
    let attr = setAndGetAttributes(this.props);
    let selectedValue = false;
    selectedValue = (value==='true')?true:(value==='TRUE' || value===true)?true:(value==='false')?false:value;
    if(selectedValue===null){
      selectedValue = false;
    }
    //console.log('selectedValue==',selectedValue)
    return (
      
          <div className="material-switch pt-2">
							<input 
                type="checkbox" 
                checked={selectedValue}
                onChange={e=>this.fieldOnChangeHandler(e)}
                {...attr}
              />
							<label htmlFor={attr.id} className="secondary_bg"></label>
					</div>
            
    );
  }
}

OnAndOffField.defaultProps = {
  disabled: false,
  readOnly:false,
  className: 'form-control'
}

export default OnAndOffField;